import dayjs from 'dayjs';

/** RA2 site_message: copy/delete day alerts */
export const MSG = {
  copy_error_unsaved:
    '更新されていないデータが存在するため、コピーできません。一度データ更新してください。',
  /** RA2: visits_copy_error_alert — 次週にコピー when next week already has visits */
  copy_week_next_week_has_data: '次週に訪問データが存在するため、コピーできません。',
  copy_target_has_treatment:
    '翌週に既に来院の登録した患者が含まれている為、コピーできません。',
  copy_day_same: '同じ日付を指定しないでください。',
  copy_day_required: 'コピー先の日付を入力してください。',
  copy_day_already_exist: 'すでにコピー先に訪問が登録されています。',
  copy_no_data: 'コピーするデータがありません。',
  copy_success: 'コピーしました。',
  copy_success_with_suddenly_visit:
    'コピーしました。突発的な往療が含まれています。確認してください。',
  /** RA2: visits_copy_massager_error_alert (massagerExists = false) */
  copy_massager_out_of_range: '施術師の適用期限外のためコピーできません。',
  /** submit-total: same patient + same date + same massager already in calendar */
  submit_patient_already_same_massager: 'この受診者はすでに登録されています。',
  delete_blocked_by_copy: 'コピーデータが存在するため削除できません。一度データ更新してください。',
  delete_confirm: (date: string) => `${date}の訪問データを全て削除します。よろしいですか？`,
  delete_locked: '既にレセプト発行済みの訪問入力がありますので削除できません。',
  /** UAT 2026-04-21: extra confirm when day has same-address patient group(s). */
  delete_same_address_warn:
    '同一日に、当該受診者と同一住所の受診者の登録があります。人数カウントに影響がある可能性がありますが削除してよろしいですか？',
  edit_blocked_by_copy: 'コピーデータが存在するため編集できません。一度データ更新してください。',
  add_blocked_by_copy: 'コピーデータが存在するため追加できません。一度データ更新してください。',
};

export const VISITDATE_DEFAULT = dayjs().format('YYYY-MM-DD');
